import { useRecoilValue } from "recoil"

import { interactionPreventionState } from "./state"

export function useIsInteractionPrevention(): boolean {
  return useRecoilValue(interactionPreventionState)
}
